export const pageSEOData = [
 {
  path:'/',
  title: 'UNITEN Official website of Universiti Tenaga Nasional',
  description: 'Official website of Universiti Tenaga Nasional (UNITEN), Malaysia’s premier energy university offering undergraduate and postgraduate programs in engineering, business, and information technology.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/campus-life',
  title: 'UNITEN Campus Life - Student Accommodation, Facilities & Activities',
  description: 'Experience vibrant campus life at UNITEN’s Putrajaya & KSHAS campuses. Explore student accommodation, 24-hour libraries, sports facilities, cultural clubs, and modern IT resources for a fulfilling university journey.',
  image: 'https://backend-service.uniten.edu.my//media/uftecqd0/campus-putrajaya-01-main-entrance.jpg',
 },
 {
  path:'/scholarships',
  title: 'UNITEN Scholarships & Financial Aid - Local & International',
  description: 'Explore UNITEN’s comprehensive scholarships and financial aid options, including PTPTN, tuition discounts, UNITEN partner scholarships, and external and international awards for your studies.',
  image: '/assets/vector2.svg',
 },
 {
  path:'/alumni-relations-career',
  title: 'UNITEN Alumni - Network, Community & Success Stories',
  description: 'Connect with the Universiti Tenaga Nasional (UNITEN) alumni network. Explore success stories, alumni benefits, events, and opportunities to engage with our global community of graduates.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/international-office',
  title: 'UNITEN International Office - Support for International Students',
  description: 'The UNITEN International Office provides comprehensive support for international students from over 30 countries, covering visa, immigration, accommodation, welfare, and cultural adjustment services.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about',
  title: 'UNITEN About Us - History, Vision & Mission',
  description: 'Discover Universiti Tenaga Nasional (UNITEN)’s rich history and evolution from a training center to a premier energy university. Learn about our leadership, milestones, and commitment to engineering, IT, and business education in Malaysia.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about?sideTab=8',
  title: 'UNITEN Academic Structure & Campuses - About Us',
  description: 'Explore UNITEN’s academic colleges (Engineering, Computing, Business, Graduate Studies) and campus information. Discover our commitment to education, research, and community involvement at Universiti Tenaga Nasional.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/our-people',
  title: 'Our People at UNITEN - Leadership, Staff & Community',
  description: 'Meet the people who make up Universiti Tenaga Nasional. Discover our esteemed leadership, dedicated staff, vibrant student body, and impactful alumni who drive UNITEN’s success and community.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/contact-us',
  title: 'Contact UNITEN - Departments, Campuses & Inquiries',
  description: 'Find contact details for Universiti Tenaga Nasional (UNITEN) departments, academic colleges, and administrative offices. Get campus addresses, phone numbers, and use our feedback form for inquiries.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes',
  title: 'UNITEN All Programmes - Undergraduate, Postgraduate & Diploma',
  description: 'Explore UNITEN’s full range of academic programmes, including foundational, diploma, bachelor’s, master’s, and PhD degrees in engineering, computing, business, and IT.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/admission',
  title: 'UNITEN Admission - Apply Now for Undergraduate & Postgraduate Programs',
  description: 'Discover UNITEN’s admission process for Malaysian and international students. Find important application dates, entry requirements, fees, scholarships, and details for undergraduate, postgraduate, and executive education programs.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/staff-hub',
  title: 'UNITEN Staff Hub - Internal Resources & Portals',
  description: 'Access essential resources for Universiti Tenaga Nasional (UNITEN) staff, including internal portals like WebMail, ESS, Microsoft Teams, and the IRC Staff portal for all your professional needs.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/student-hub',
  title: 'UNITEN Student Hub - Resources & Essential Portals',
  description: 'Access the UNITEN Student Hub for essential resources, including Moodle, Student Info System, academic calendars, forms, and information on internships and convocation for a seamless university experience.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/academic-calendar',
  title: 'UNITEN Academic Calendar 2025/2026 - Undergraduate & Postgraduate',
  description: 'View and download the official UNITEN Academic Calendar for the 2025/2026 academic year. Find key dates for undergraduate and postgraduate programs (Structures A, B & C) at Universiti Tenaga Nasional.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/news-events',
  title: 'UNITEN News & Events - Latest Updates & University Happenings',
  description: 'Stay informed with the latest news, announcements, and upcoming events from Universiti Tenaga Nasional (UNITEN). Discover university happenings, achievements, and important updates.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/research',
  title: 'UNITEN Research - Energy Informatics & Sustainable Innovation',
  description: 'Explore UNITEN’s cutting-edge research and innovation, with a focus on energy informatics through institutes like IICE and distinguished chairs. Discover our contributions to the energy industry and sustainable development.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/training-services',
  title: 'UNITEN Training & Professional Services',
  description: 'Discover UNITEN’s professional training courses, executive education programs, and specialized services offered to industries, organizations, and the community.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about?sideTab=1',
  title: 'About UNITEN - Mission, Vision & Core Values',
  description: 'Learn about Universiti Tenaga Nasional (UNITEN)’s core identity. Discover our mission, vision, and values that guide our commitment to academic excellence and leadership in the energy sector.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about?sideTab=2',
  title: 'UNITEN Structure & Governance - About Us',
  description: 'Understand Universiti Tenaga Nasional (UNITEN)’s organizational structure, leadership, and governance. Explore our commitment to academic standards and institutional excellence.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about?sideTab=3',
  title: 'UNITEN Official Song - About Us',
  description: 'Discover key facts, achievements, and milestones of Universiti Tenaga Nasional (UNITEN). Learn about our commitment to academic excellence and contributions to education.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about?sideTab=4',
  title: 'UNITEN Strategic Future Goals - About Us',
  description: 'Explore UNITEN’s BOLD2025 Strategic Plan, aiming to be a leading global energy university by 2030. Discover our vision, research excellence, and achievements in QS University Rankings.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about?sideTab=6',
  title: 'Why Choose UNITEN? Top Advantages & Study Benefits - About Us',
  description: 'Discover the advantages of studying at UNITEN: accredited programs, modern campus, strategic location, practical training with TNB, and industry-focused education for strong career prospects.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about?sideTab=7',
  title: 'UNITEN About Hall Of Fame',
  description: 'Since 1998, the university has produced 41,499 graduates. The role of the university’s graduates are important towards developing and contributing back to the community and nation. Among them, there are those who have achieved big success, locally and internationally, in their own chosen professions. UNITEN is proud to have them as part of the alumni.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/about?sideTab=8',
  title: 'UNITEN Colleges - Academic Structure & Engineering Programs',
  description: 'Explore UNITEN’s academic colleges, including the College of Engineering (COE). Discover our cutting-edge education and research, where faculty and students contribute to a vibrant university community.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-engineering-coe',
  title: 'UNITEN College of Engineering (COE) - Accredited Engineering Programs',
  description: 'Explore UNITEN’s College of Engineering (COE), offering MQA, BEM, and Washington Accord accredited engineering programs from foundation to PhD, with strong industry linkages for career-resilient engineers.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-engineering-coe?tab=0',
  title: 'About UNITEN College of Engineering (COE)',
  description: 'Learn about UNITEN’s College of Engineering (COE), its mission, vision, and commitment to delivering quality engineering education and fostering innovation.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-engineering-coe?tab=1',
  title: 'UNITEN COE Our People - Faculty, Staff & Researchers',
  description: 'Meet the dedicated faculty, staff, and researchers of UNITEN’s College of Engineering (COE). Explore their expertise and contributions to engineering education and innovation.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-engineering-coe?tab=2',
  title: 'UNITEN COE Departments - Civil, Electrical & Engineering Disciplines',
  description: 'Explore the academic departments within UNITEN’s College of Engineering (COE), including Civil Engineering and Electrical & Electronics Engineering, offering full-time undergraduate and postgraduate programs.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-engineering-coe?tab=3',
  title: 'UNITEN COE News & Updates - Latest Engineering News',
  description: 'Stay informed with the latest news, announcements, and updates from Universiti Tenaga Nasional’s College of Engineering (COE). Discover our achievements, events, and important notices.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-engineering-coe?tab=4',
  title: 'UNITEN COE Research - Innovation, Consultancy & Research Bytes',
  description: 'Explore cutting-edge research and innovation at UNITEN’s College of Engineering (COE). Discover our quality research, consultancy services, and the accomplishments of our esteemed researchers through COE Research Bytes.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-computing-informatics-cci',
  title: 'UNITEN College of Computing & Informatics (CCI) - AI, Cybersecurity & IT Programs',
  description: 'Explore UNITEN’s College of Computing & Informatics (CCI), offering industry-relevant programs in Computer Science (AI, Cyber Security, Software Engineering) and Information Technology. Benefit from strong industry backing and global university partnerships.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-computing-informatics-cci?tab=1',
  title: 'UNITEN CCI Our People - Faculty & Staff Directory',
  description: 'Meet the esteemed faculty and staff of UNITEN’s College of Computing & Informatics (CCI). Explore their profiles and expertise in computer science, IT, and related fields.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-computing-informatics-cci?tab=2',
  title: 'UNITEN CCI Departments - Computing & IT Disciplines',
  description: 'Explore the academic departments within UNITEN’s College of Computing & Informatics (CCI). Discover our specialized areas in computer science, information technology, and data science.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-computing-informatics-cci?tab=3',
  title: 'UNITEN CCI News & Updates - Latest Computing & IT Info',
  description: 'Stay informed with the latest news, announcements, and updates from UNITEN’s College of Computing & Informatics (CCI). Discover our achievements, events, and important notices in technology and research.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-computing-informatics-cci?tab=4',
  title: 'UNITEN CCI Research - Computing & IT Innovation',
  description: 'Explore research activities and innovation at UNITEN’s College of Computing & Informatics (CCI). Discover our contributions to advanced computing, data science, and information technology.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/uniten-business-school-ubs',
  title: 'UNITEN Business School (UBS) - Accounting, Finance & Management Programs',
  description: 'Discover UNITEN Business School (UBS), offering first-class, accredited programs in accounting, finance, business, and economics. Prepare for industry success with strong professional recognition and high employability rates.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/uniten-business-school-ubs?tab=1',
  title: 'UNITEN UBS Our People - Business Faculty & Staff',
  description: 'Meet the dedicated faculty, lecturers, and staff of UNITEN Business School (UBS). Explore their expertise in accounting, finance, management, and economics.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/uniten-business-school-ubs?tab=2',
  title: 'UNITEN UBS Departments - Business & Economic Disciplines',
  description: 'Explore the academic departments within UNITEN Business School (UBS). Discover our specialized areas of study in accounting, finance, business management, and economics.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/uniten-business-school-ubs?tab=3',
  title: 'UNITEN UBS News & Updates - Latest Business School Info',
  description: 'Stay informed with the latest news, announcements, and updates from UNITEN Business School (UBS). Discover our achievements, events, and important notices in the business and economic fields.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/uniten-business-school-ubs?tab=4',
  title: 'UNITEN UBS Research - Business & Economic Insights',
  description: 'Explore research initiatives and scholarly work at UNITEN Business School (UBS). Discover our contributions to business, finance, and economic insights through faculty and student research.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-graduate-studies-cogs',
  title: 'UNITEN College of Graduate Studies (COGS) - Postgraduate Programs & Research',
  description: 'Explore UNITEN’s College of Graduate Studies (COGS) for MQA-accredited Master’s & PhD programs in engineering, IT, and business. Advance your career through research innovation, industrial collaboration, and diverse study opportunities.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-graduate-studies-cogs?tab=1',
  title: 'UNITEN COGS Our People - Graduate Studies Faculty & Supervisors',
  description: 'Meet the dedicated faculty, supervisors, and staff of UNITEN’s College of Graduate Studies (COGS). Explore their expertise in guiding postgraduate research and studies.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-graduate-studies-cogs?tab=2',
  title: 'UNITEN COGS Departments - Postgraduate Study Disciplines',
  description: 'Explore the academic departments overseeing postgraduate studies at UNITEN’s College of Graduate Studies (COGS). Discover the diverse disciplines available for your Master’s and PhD research.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-graduate-studies-cogs/cogs-student-guide',
  title: 'UNITEN COGS Student Guide - Postgraduate Resources & Forms',
  description: 'Access the comprehensive UNITEN COGS Student Guide for postgraduate students. Find academic regulations, thesis guidelines, administrative forms, and essential resources for your Master’s and PhD journey.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-graduate-studies-cogs?tab=4',
  title: 'UNITEN COGS Graduate Activity Club (GAC) - Postgraduate Student Life',
  description: 'Discover UNITEN’s Graduate Activity Club (GAC), a vibrant social and study hub for postgraduate students and staff. Engage in projects, seminars, workshops, and social activities.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-continuing-education-cced',
  title: 'UNITEN College of Continuing Education (CCEd) - Lifelong Learning & Executive Diplomas',
  description: 'Discover UNITEN’s College of Continuing Education (CCEd) for diverse programs including languages, preparatory courses, and executive diplomas. Develop industry-ready skills and embrace lifelong learning with our comprehensive offerings and APEL admissions.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-continuing-education-cced?tab=1',
  title: 'UNITEN CCEd Our People - Continuing Education Faculty & Staff',
  description: 'Meet the experienced faculty and dedicated staff of UNITEN’s College of Continuing Education (CCEd). Explore our team committed to lifelong learning and professional development.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-continuing-education-cced?tab=2',
  title: 'UNITEN CCEd Departments - Lifelong Learning & Professional Development',
  description: 'Explore the departments within UNITEN’s College of Continuing Education (CCEd), offering diverse programs in social sciences, languages, communication, and APEL for lifelong learning.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-continuing-education-cced?tab=3',
  title: 'UNITEN CCEd Services - English, Tourism & Short Courses',
  description: 'Explore the diverse services offered by UNITEN’s College of Continuing Education (CCEd), including Intensive English Programme (IEP), EDU-TOURISM, ELEVATE, and various short courses for professional development.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-continuing-education-cced?tab=4',
  title: 'UNITEN CCEd News & Updates - Latest Continuing Education Info',
  description: 'Stay informed with the latest news, announcements, and updates from UNITEN’s College of Continuing Education (CCEd). Discover upcoming events, courses, and highlights in lifelong learning and professional development.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/college/college-of-continuing-education-cced?tab=5',
  title: 'UNITEN CCEd Research - Continuing Education Innovations',
  description: 'Explore research initiatives and scholarly activities at UNITEN’s College of Continuing Education (CCEd). Discover our contributions to lifelong learning, professional development, and educational innovation.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/campus-Life/KSHAS-Campus',
  title: 'UNITEN KSHAS Campus Life & Facilities - Sultan Haji Ahmad Shah',
  description: 'Explore campus life at UNITEN’s Sultan Haji Ahmad Shah (KSHAS) Campus. Discover modern libraries, accommodation, sports facilities, cultural activities, and comprehensive student amenities at Universiti Tenaga Nasional.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/training-services/bem-gap',
  title: 'UNITEN BEM-GAP - Electrical Engineering Top-Up for Graduate Engineer Registration',
  description: 'Discover UNITEN’s 2-year BEM Graduate Assessment Program (BEM-GAP) in Electrical Engineering. Designed for various qualifications, this top-up program prepares you for Board of Engineers Malaysia (BEM) Graduate Engineer registration with flexible weekday and weekend classes.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-engineering-coe/foundation-in-engineering',
  title: 'UNITEN Foundation in Engineering - Prepare for Your Engineering Degree',
  description: 'Embark on your engineering journey with UNITEN’s one-year Foundation in Engineering program. Designed for comprehensive preparation, this MQA & EAC accredited course covers core subjects, practical training, and sets you on a path to a successful engineering career.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-engineering-coe/diploma-in-mechanical-engineering',
  title: 'UNITEN Diploma in Mechanical Engineering - Practical Skills & High Employability',
  description: 'Gain practical mechanical engineering skills with UNITEN’s 2.5-year Diploma program. MQA & EAC accredited, this course emphasizes hands-on training, leading to a 94% graduate employability rate and strong career prospects in the engineering field.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-engineering-coe/diploma-in-electrical-engineering',
  title: 'UNITEN Diploma in Electrical Engineering - Industry-Ready & Practical Skills',
  description: 'Master electrical engineering with UNITEN’s 2.5-year Diploma. This industry-focused program, offering comprehensive subjects and practical training, prepares you for a rewarding career with high employability and recognized accreditations.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-engineering-coe/bachelor-of-electrical-and-electronics-engineering-honours',
  title: 'UNITEN Bachelor of Electrical & Electronics Engineering (Hons) - Industry-Ready Program',
  description: 'Earn your Bachelor of Electrical and Electronics Engineering (Hons) at UNITEN. This 4-year, MQA & EAC accredited program offers industry-aligned curriculum, practical projects, and a 97.7% employability rate for a successful career in diverse electrical and electronics fields.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-engineering-coe/bachelor-of-electrical-power-engineering-honours',
  title: 'UNITEN Bachelor of Electrical Power Engineering (Hons) - Power Systems & Industry Ready',
  description: 'Advance your career with UNITEN’s 4-year Bachelor of Electrical Power Engineering (Hons). This industry-aligned program covers power systems, electronics, and high voltage technology, preparing graduates for professional engineering roles with strong career prospects and recognized accreditations.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-engineering-coe/bachelor-of-mechanical-engineering-honours',
  title: 'UNITEN Bachelor of Mechanical Engineering (Hons) - Industry-Focused & Accredited',
  description: 'Pursue a 4-year Bachelor of Mechanical Engineering (Hons) at UNITEN, featuring a practical curriculum with industrial training. This MQA & EAC accredited program boasts a 97.7% employability rate, preparing you for a successful career in mechanical engineering.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-engineering-coe/bachelor-of-civil-engineering-honours',
  title: 'UNITEN Bachelor of Civil Engineering (Hons) - Structures, Geotech & Construction',
  description: 'Pursue a 4-year Bachelor of Civil Engineering (Hons) at UNITEN. This MQA & EAC accredited program covers structural, geotechnical, water, and environmental engineering with practical projects, industrial training, and a 97.7% employability rate for a strong career.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/huffaz-professional/pensijilan-tahfiz-al-quran-jakim-uniten-engineering',
  title: 'UNITEN Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) - Engineering & Islamic Sciences',
  description: 'Discover UNITEN’s unique Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) program, integrating Al-Quran memorization with professional fields like engineering. This 2 ⅓-year program fosters holistic graduates with strong employability and flexible payment options.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/foundation-in-computer-science',
  title: 'UNITEN Foundation in Computer Science - Pathway to IT & Computing Degrees',
  description: 'Launch your IT career with UNITEN’s one-year Foundation in Computer Science. This hands-on program covers computing, web development, and data fundamentals, leading to Bachelor of Computer Science degrees with a 97.78% employability rate.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/foundation-in-information-technology',
  title: 'UNITEN Foundation in IT - Pathway to Information Technology Degrees',
  description: 'Start your IT journey with UNITEN’s one-year Foundation in Information Technology. This MQA-accredited program offers hands-on learning in computing, web development, and data fundamentals, preparing you for specialized IT degrees and a high-employability career.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/diploma-in-computer-science',
  title: 'UNITEN Diploma in Computer Science - Industry-Ready & High Employability',
  description: 'Launch your career with UNITEN’s 2.5-year Diploma in Computer Science. This MQA-accredited program offers a practical, industry-aligned syllabus covering UX Design, Data Science, and networking, leading to a 97.78% employability rate in software, web, and AI engineering roles.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/bachelor-in-computer-science-artificial-intelligence-honours',
  title: 'UNITEN Bachelor of Computer Science (AI Hons) - Machine Learning & Generative AI',
  description: 'Master cutting-edge AI with UNITEN’s 3-year Bachelor of Computer Science (Artificial Intelligence) (Hons). This program covers machine learning, NLP, computer vision, and ethical AI, preparing you for high-demand roles with hands-on projects and industry exposure.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/bachelor-in-computer-science-cyber-security-honours',
  title: 'UNITEN Bachelor of Computer Science (Cyber Security Hons) - Protect Digital Assets',
  description: 'Master cyber security with UNITEN’s 3-year Bachelor of Computer Science (Cyber Security) (Hons). This program covers cryptography, network security, and ethical hacking, preparing you for high-demand roles in protecting digital infrastructure with industry insights from TNB.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/bachelor-in-software-engineering-honours',
  title: 'UNITEN Bachelor of Software Engineering (Hons) - Industry-Ready Developers',
  description: 'Develop cutting-edge software with UNITEN’s 3-year Bachelor of Software Engineering (Hons). This program offers a practical, industry-aligned curriculum in programming, cybersecurity, and database management, preparing you for high-demand roles with excellent career prospects and scholarship opportunities.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/bachelor-in-computer-science-systems-and-networking-honours',
  title: 'UNITEN Bachelor of Computer Science (Systems & Networking Hons) - IR4.0 Ready',
  description: 'Become a networking and systems expert with UNITEN’s 3-year Bachelor of Computer Science (Systems & Networking) (Hons). This MQA-accredited program aligns with IR4.0, covering communications, cybersecurity, and operating systems, ensuring high employability in modern computing careers.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/bachelor-in-information-systems-business-analytics-honours',
  title: 'UNITEN Bachelor of Info Systems (Business Analytics Hons) - Data-Driven Insights',
  description: 'Master data-driven strategies with UNITEN’s 3-year Bachelor in Information Systems (Business Analytics) (Hons). This program blends IT and business analytics, covering data engineering and cybersecurity to prepare you for roles as a Business Analyst or Data Scientist, with a 97.78% employability rate.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/bachelor-of-information-technology-graphics-multimedia-honours',
  title: 'UNITEN Bachelor of IT (Graphics & Multimedia Hons) - Creative Tech & Gaming',
  description: 'Unleash your creativity with UNITEN’s 3-year Bachelor of Information Technology (Graphics & Multimedia) (Hons). This program focuses on computer graphics, 3D animation, VR/AR, and game development, preparing you for dynamic careers in multimedia with a 97.78% employability rate.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/huffaz-professional/pensijilan-tahfiz-al-quran-jakim-uniten-computer-science',
  title: 'UNITEN Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) - Computer Science & Islamic Sciences',
  description: 'Discover UNITEN’s unique Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) program, integrating Al-Quran memorization with Computer Science. This 2 ⅓-year program fosters holistic graduates with strong employability (94% rate) and offers scholarships.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/huffaz-professional/pensijilan-tahfiz-al-quran-jakim-uniten-information-technology',
  title: 'UNITEN Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) - IT & Islamic Sciences',
  description: 'Discover UNITEN’s unique Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) program, integrating Al-Quran memorization with Information Technology. This 2 ⅓-year program fosters holistic graduates with strong employability (94% rate) and offers scholarships.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/foundation-in-accounting',
  title: 'UNITEN Foundation in Accounting - Pathway to Business & Finance',
  description: 'Prepare for your accounting degree with UNITEN’s Foundation in Accounting program. Gain essential foundational knowledge in financial principles, preparing you for success in business and finance studies.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/foundation-in-business-administration',
  title: 'UNITEN Foundation in Business Administration - Kickstart Your Business Career',
  description: 'Lay the groundwork for a successful business career with UNITEN’s Foundation in Business Administration. This program equips you with core business knowledge for advanced studies in management, marketing, and more.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-continuing-education-cced/foundation-in-management',
  title: 'UNITEN Foundation in Management (CCEd) - Develop Leadership Skills',
  description: 'Build essential leadership and organizational skills with UNITEN CCEd’s Foundation in Management program. This course prepares you for further studies in various management-related fields.',
  image: 'https://backend-service.uniten.edu.my//media/uftecqd0/campus-putrajaya-01-main-entrance.jpg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/diploma-in-accounting',
  title: 'UNITEN Diploma in Accounting - Practical Skills for Finance Careers',
  description: 'Gain practical accounting expertise with UNITEN’s Diploma in Accounting. This program provides essential skills for finance roles and serves as a strong stepping stone for further academic progression in accounting.',
  image: '/assets/vector2.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/diploma-in-business-studies',
  title: 'UNITEN Diploma in Business Studies - Comprehensive Business Education',
  description: 'Acquire a broad understanding of business operations with UNITEN’s Diploma in Business Studies. This program offers practical knowledge across various business functions, preparing you for diverse career opportunities or degree pathways.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/diploma-in-digital-business',
  title: 'UNITEN Diploma in Digital Business - Master E-commerce & Digital Strategies',
  description: 'Step into the digital economy with UNITEN’s Diploma in Digital Business. Learn about e-commerce, digital marketing, and online business strategies, equipping you for the evolving digital landscape.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/diploma-in-financial-technology',
  title: 'UNITEN Diploma in Financial Technology (FinTech) - Innovate Finance',
  description: 'Explore the cutting edge of finance with UNITEN’s Diploma in Financial Technology (FinTech). This program blends finance with technology, preparing you for innovative roles in the rapidly growing FinTech industry.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/bachelor-in-accounting-honours',
  title: 'UNITEN Bachelor of Accounting (Hons) - Professional Accounting Career',
  description: 'Achieve professional recognition with UNITEN’s Bachelor of Accounting (Honours) program. Develop in-depth accounting knowledge and practical skills, preparing you for a successful career as a certified accountant or further postgraduate studies.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/bachelor-in-finance-honours',
  title: 'UNITEN Bachelor of Finance (Hons) - Global Financial Markets',
  description: 'Dive into global finance with UNITEN’s Bachelor of Finance (Honours) program. Gain expertise in financial analysis, investment, and market strategies, preparing you for diverse roles in the finance industry.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/bachelor-in-international-business-honours',
  title: 'UNITEN Bachelor of International Business (Hons) - Global Commerce & Strategy',
  description: 'Lead in the global marketplace with UNITEN’s Bachelor of International Business (Honours). This program equips you with strategies for cross-border operations, global trade, and multinational management.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/bachelor-in-business-administration-marketing-honours',
  title: 'UNITEN BBA (Marketing Hons) - Digital & Strategic Marketing Expertise',
  description: 'Become a marketing leader with UNITEN’s Bachelor in Business Administration (Marketing) (Honours). Develop expertise in digital marketing, brand management, and consumer behavior to drive business growth.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/bachelor-in-business-administration-human-resource-management-honours',
  title: 'UNITEN BBA (HR Management Hons) - Cultivate Talent & HR Strategy',
  description: 'Shape organizational success with UNITEN’s Bachelor in Business Administration (Human Resource Management) (Honours). Learn to manage talent, foster positive workplaces, and develop effective HR strategies.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/uniten-business-school-ubs/bachelor-in-business-administration-entrepreneurship-and-venture-management-honours',
  title: 'UNITEN BBA (Entrepreneurship & Venture Management Hons) - Innovate & Lead',
  description: 'Ignite your entrepreneurial spirit with UNITEN’s Bachelor in Business Administration (Entrepreneurship and Venture Management) (Honours). Learn to identify opportunities, launch new ventures, and manage business growth.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-continuing-education-cced/bachelor-in-business-economics-honours',
  title: 'UNITEN CCEd Bachelor in Business Economics (Hons) - Economic Insights for Business',
  description: 'Gain a competitive edge with UNITEN CCEd’s Bachelor in Business Economics (Honours). This program combines economic theory with business applications, preparing you to analyze markets and inform strategic decisions.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-continuing-education-cced/bachelor-in-economics-energy-honours',
  title: 'UNITEN CCEd Bachelor in Economics (Energy Hons) - Powering Energy Sector Careers',
  description: 'Specialize in the dynamic energy sector with UNITEN CCEd’s Bachelor in Economics (Energy) (Honours). This unique program focuses on energy markets, policy, and sustainability, preparing you for key roles in the power industry.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/huffaz-professional/pensijilan-tahfiz-al-quran-jakim-uniten-accounting',
  title: 'UNITEN Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) - Accounting & Islamic Sciences',
  description: 'Integrate spiritual and professional growth with UNITEN’s Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) in Accounting. This program combines rigorous accounting studies with Al-Quran memorization, fostering ethical and skilled professionals.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/huffaz-professional/pensijilan-tahfiz-al-quran-jakim-uniten-business-administration',
  title: 'UNITEN Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) - Business Admin & Islamic Sciences',
  description: 'Develop holistic business leadership with UNITEN’s Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) in Business Administration. This program blends comprehensive business studies with Al-Quran memorization, preparing ethical and competent leaders for various industries.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/huffaz-professional/pensijilan-tahfiz-al-quran-jakim-uniten-economics-and-management',
  title: 'UNITEN Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) - Economics, Management & Islamic Sciences',
  description: 'Gain a unique perspective in economics and management with UNITEN’s Pensijilan Tahfiz Al-Quran (JAKIM-UNITEN) program. This course integrates economic principles and management skills with Al-Quran memorization, fostering well-rounded and ethical professionals.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-science-in-electrical-engineering-by-research',
  title: 'UNITEN MSc Electrical Engineering (Research) - Advanced Power & Electronics',
  description: 'Pursue a Master of Science in Electrical Engineering by Research at UNITEN. Conduct advanced research in power systems, electronics, and related fields to contribute to cutting-edge innovations.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-science-in-mechanical-engineering-by-research',
  title: 'UNITEN MSc Mechanical Engineering (Research) - Advanced Mechanical Systems',
  description: 'Undertake a Master of Science in Mechanical Engineering by Research at UNITEN. Focus on innovative research in areas like thermodynamics, fluid mechanics, and advanced materials for mechanical applications.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-science-in-civil-engineering-by-research',
  title: 'UNITEN MSc Civil Engineering (Research) - Sustainable Infrastructure Solutions',
  description: 'Engage in advanced research with UNITEN’s Master of Science in Civil Engineering by Research. Explore innovative solutions in structural engineering, geotechnics, transportation, and water resources for sustainable development.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-science-in-accounting-by-research',
  title: 'UNITEN MSc Accounting (Research) - Advanced Financial & Audit Studies',
  description: 'Deepen your expertise with UNITEN’s Master of Science in Accounting by Research. Conduct advanced studies in financial reporting, auditing, taxation, and contemporary accounting issues to shape future practices.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-science-in-finance-by-research',
  title: 'UNITEN MSc Finance (Research) - Capital Markets & Financial Innovation',
  description: 'Pursue a Master of Science in Finance by Research at UNITEN. Explore advanced topics in capital markets, financial instruments, corporate finance, and risk management through rigorous academic inquiry.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-science-in-management-by-research',
  title: 'UNITEN MSc Management (Research) - Strategic Leadership & Organizational Studies',
  description: 'Advance your management expertise with UNITEN’s Master of Science in Management by Research. Conduct in-depth studies on organizational behavior, strategic management, innovation, and leadership.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-continuing-education-cced/master-in-energy-management-by-coursework-project',
  title: 'UNITEN Master in Energy Management (Coursework & Project) - Sustainable Energy Leadership',
  description: 'Become a leader in sustainable energy with UNITEN’s Master in Energy Management. This coursework and project-based program equips you with expertise in energy efficiency, renewable sources, and policy for a green future.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-business-administration-by-coursework-project',
  title: 'UNITEN Master of Business Administration (MBA) - Strategic Business Leadership',
  description: 'Elevate your career with UNITEN’s Master of Business Administration (MBA). This coursework and project-based program develops strategic leadership, management, and entrepreneurial skills for diverse business challenges.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-business-administration-by-coursework-project-open-and-distance-learning',
  title: 'UNITEN Online MBA (ODL) - Flexible Business Leadership via Distance Learning',
  description: 'Achieve your MBA flexibly with UNITEN’s Open and Distance Learning (ODL) program. This online Master of Business Administration offers strategic leadership and management skills for working professionals worldwide.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/doctor-of-philosophy-business-management',
  title: 'UNITEN PhD in Business Management - Doctoral Research in Business Strategy',
  description: 'Pursue a Doctor of Philosophy in Business Management at UNITEN. Conduct advanced, original research to contribute new knowledge and insights to the fields of business strategy, organizational theory, and management.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-in-electrical-engineering-by-coursework-research',
  title: 'UNITEN Master in Electrical Engineering (Coursework & Research) - Advanced Specializations',
  description: 'Advance your electrical engineering career with UNITEN’s Master’s program. This blended coursework and research degree offers specialized knowledge in power systems, electronics, and control, driving innovation in the industry.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-in-engineering-management-by-coursework-project',
  title: 'UNITEN Master in Engineering Management (Coursework & Project) - Lead Technical Teams',
  description: 'Bridge engineering and business with UNITEN’s Master in Engineering Management. This program equips engineers with leadership, project management, and strategic decision-making skills for complex technical initiatives.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-in-structural-engineering-by-coursework-project',
  title: 'UNITEN Master in Structural Engineering (Coursework & Project) - Design Resilient Structures',
  description: 'Specialize in structural design with UNITEN’s Master in Structural Engineering. This program focuses on advanced analysis, design, and construction of resilient structures through coursework and practical projects.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/doctor-of-philosophy-engineering',
  title: 'UNITEN Doctor of Philosophy (PhD) in Engineering - Frontier Research & Innovation',
  description: 'Embark on groundbreaking research with UNITEN’s Doctor of Philosophy (PhD) in Engineering. Contribute original knowledge to electrical, mechanical, civil, or other engineering disciplines and drive technological advancements.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-of-science-in-information-technology-by-research',
  title: 'UNITEN MSc Information Technology (Research) - Innovative IT Solutions',
  description: 'Conduct advanced research in Information Technology with UNITEN’s Master of Science program. Explore cutting-edge IT trends, develop innovative solutions, and contribute to the digital transformation landscape.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/master-in-information-technology-by-coursework-research',
  title: 'UNITEN Master in Information Technology (Coursework & Research) - Applied IT Expertise',
  description: 'Enhance your IT expertise with UNITEN’s Master in Information Technology. This blended program offers advanced coursework in diverse IT fields alongside research opportunities to deepen your specialization.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/master-in-artificial-intelligence-by-coursework-project',
  title: 'UNITEN Master in Artificial Intelligence (Coursework & Project) - AI Development & Application',
  description: 'Become an AI expert with UNITEN’s Master in Artificial Intelligence. This program combines rigorous coursework with practical projects in machine learning, deep learning, and natural language processing for real-world AI applications.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-computing-informatics-cci/master-in-data-science-by-coursework-project',
  title: 'UNITEN Master in Data Science (Coursework & Project) - Advanced Data Analytics',
  description: 'Unlock the power of data with UNITEN’s Master in Data Science. This program offers advanced coursework and projects in big data analytics, machine learning, and statistical modeling to drive data-driven insights.',
  image: '/assets/logo-light.svg',
 },
 {
  path:'/all-programmes/college-of-graduate-studies-cogs/doctor-of-philosophy-in-information-communication-technology',
  title: 'UNITEN PhD in ICT - Doctoral Research in Information & Communication Technology',
  description: 'Lead innovation in ICT with UNITEN’s Doctor of Philosophy (PhD) in Information & Communication Technology. Conduct impactful, original research in cutting-edge areas of IT, networking, and digital communication.',
  image: '/assets/logo-light.svg',
 },
];